module.exports = __webpack_public_path__ + "54cf98f5/img/revit-icon.5ff0d581.svg";